import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import RichText from "../shared/rich-text.vue";
import { BaseControl } from "../../controls";
let Description = class Description extends BaseControl {
    get align() {
        return this.controlOpts.align;
    }
};
Description = tslib_1.__decorate([
    Component({
        name: "description",
        components: {
            RichText
        }
    })
], Description);
export default Description;
